define([
	"dojo/_base/declare",
	"underscore",
	"csi",
	"csi/heading/Container",
	"csi/html"
], function(declare,_,csi,Container,html) {

	return declare(Container, {
		bSort: true,
		queryOps: null,

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: only allow filtering for blanks / non-blanks
			var qs = this.inherited(arguments);
			if (qs) {
				qs.blanksOnly = true;
				qs.id = h.m_id;
			}

			return qs;
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render list of files
			var value = this._getValue(ctx, h);
			var names = csi.sort(this._getTextValues(ctx, h, value));
			if (names.length) {
				var	sep = this._getSeparator(h);

				ctx.pushParams();
				ctx.setReadOnly(true);

				_.each(names, function(key, i) {
					if (i && sep) {
						html.textSeparator(sep, refNode);
					}

					ctx.keyValue = key;
					this.toHtmlStatic(ctx, h, html.create("span", null, refNode));
				}, this.renBase);

				ctx.keyValue = null;
				ctx.pop();
				return true;
			}

			return false;
		},

		_getSortValues: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*String[]*/textValues) {
			// summary: sort by given text values
			return textValues;
		},

		_getTextValues: function(/*Context*/ctx, /*Heading*/h, /*Any*/value) {
			// summary: return sorted array of keys
			return _.keys(value);
		}
	});
});